module.exports = __webpack_public_path__ + "static/img/icon_ysp.076546b9.png";